var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMarker2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.999998 15.9476L0.999999 5C0.999999 2.79086 2.79086 1 5 1L32 1C34.2091 1 36 2.79086 36 5L36 15.9704C36 17.2427 35.3947 18.4392 34.3696 19.1929L20.9877 29.0328C19.5866 30.0631 17.6804 30.07 16.2719 29.0499L2.65376 19.1872C1.61501 18.4349 0.999997 17.2302 0.999998 15.9476Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.999998 19.9476L0.999999 9C0.999999 6.79086 2.79086 5 5 5L32 5C34.2091 5 36 6.79086 36 9L36 19.9704C36 21.2427 35.3947 22.4392 34.3696 23.1929L20.9877 33.0328C19.5866 34.0631 17.6804 34.07 16.2719 33.0499L2.65376 23.1872C1.61501 22.4349 0.999997 21.2302 0.999998 19.9476Z",
    fill: "#FFCE67",
    stroke: "black",
    strokeWidth: 3
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarker2);
export default __webpack_public_path__ + "static/media/marker-2.4f36358a1622b4b94ce0aca8d35b79bf.svg";
export { ForwardRef as ReactComponent };